import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import styled from "styled-components";

export default makeStyles((theme) => ({
    spinner: {
        marginLeft: 15,
        position: "relative",
        top: 4,
    },
    link: {
        textDecoration: "none",
        color: theme.palette.primary.main,
        //fontSize: '1rem'

    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.overlayBg.background,
    },
    overlay: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.overlayBg.background,
        zIndex: 2,
        cursor: 'pointer'
    },
    statusBg: {
        borderRadius: '2px',
        textTransform: 'uppercase',
        fontSize: '10px',
        fontWeight: '600',
        letterSpacing: '1px',
        paddingRight: '12px',
        paddingLeft: '12px'

    },
    axaLabel:{
        height: '24px',
        color: '#333333',
        fontFamily: "Source Sans Pro",
        fontSize: '16px',
        fontWeight: '600',
        letterSpacing: '0',
        lineHeight: '14px',
    },
    childDataCss:{
        display: 'table-cell !important',
        padding: '10px !important',
        fontSize: '0.875rem !important',
        textAlign: 'left !important',
        fontFamily: 'Source Sans Pro !important',
        fontWeight: '400 !important',
        lineHeight: '1.43 !important',
        borderBottom: 'unset !important',
        verticalAlign: 'inherit !important',
    }
}));


export const getMuiTheme = (selectedTheme) => {
    return createMuiTheme({
        ...selectedTheme,
        overrides: {
            // MuiBackdrop:{
            //     root:{
            //         backgroundColor: "rgba(0, 0, 0, 0.1)"
            //     }
            // },
            MUIDataTableSelectCell:{
                headerCell:{
                    backgroundColor: '#494DF4 !important'
                }
            },
            MuiToolbar: {
                root: {
                    padding: "0px",
                    fontFamily: "Source Sans Pro"
                },
                regular: {
                    minHeight: 'unset !important'
                },
                gutters: {
                    paddingLeft: '5px !important',
                    // paddingRight: '5px !important'
                }

            },
            MUIDataTable:{
                paper:{
                    borderRadius:'8px',
                    border:'1px solid rgba(0, 0, 0, 0.12)',
                    backgroundColor:'#E5E5E5'
                },
                responsiveBase:{
                    borderRadius:'8px'
                }
               
            },
            MuiTableHead:{
                root:{
                    background:'blue',
                    color:'white'
                }
            },
            MUIDataTableToolbar: {
                paddingLeft: '10px',
                titleText: {
                    fontSize: '14px !important',
                }
            },
            MUIDataTableToolbarSelect: {

                title: {
                    display: 'none',
                    paddingLeft: '10px'
                }
            },

            MuiTableCell: {
                root: {
                    fontFamily: "Source Sans Pro",
                    // border: '#ccc solid thin',
                    padding: 10,
                    //fontSize: '0.875rem',
                    borderBottom:'unset'
                },

            },
            MUIDataTableBodyCell: {
                root: {
                    // // padding: "2px",
                    // fontSize: '12px',
                    // // border: '#ccc solid thin',

                    // // eslint-disable-next-line no-useless-computed-key
                    // ["@media (min-width:959.5px)"]: {
                    //     // padding: "0px 2px",
                    // },
                },

            },
            MUIDataTableHeadCell: {
                root: {
                    // padding: "0px 2px",
                    // fontSize: '13px',
                    // top: '0px',
                    // position: 'sticky',
                    // // padding: '6px',
                    // border: '#ccc solid thin',
                    // fontSize: '13px',
                    // borderBottom: 'none',

                },
                fixedHeader:{
                    backgroundColor:selectedTheme.palette.primary.main,
                    color:selectedTheme.palette.primary.text
                }
            },
            PrivateSwitchBase: {
                root: {
                    padding: "4px 0px 4px 4px"
                }
            },
            MuiIconButton: {
                root: {
                    padding: "6px"
                }
            },
            MuiTableSortLabel: {
                root: {
                    marginTop: 5
                }
            },
            MuiTablePagination: {
                caption: {
                    //fontSize: '0.775rem',
                }
            },
            MuiPaper:{
                elevation4:{
                    boxShadow:'none'
                },
                // elevation24:{
                //     boxShadow:"0px 11px 15px -7px rgb(0 0 0 / 0%), 0px 24px 38px 3px rgb(0 0 0 / 0%), 0px 9px 46px 8px rgb(0 0 0 / 0%)"
                // }
            }
        },
    })
}
